import { Chevron, Select } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type SortDailyTasksProps = {
  setSortOrder: (sortOrder: '-1' | '1') => void
}

const SortDailyTasks = ({ setSortOrder }: SortDailyTasksProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)
  const sortingOptions = [
    { label: t(toDosConstants.SORT_DESCENDING), value: '-1' },
    { label: t(toDosConstants.SORT_ASCENDING), value: '1' },
  ]
  return (
    <Wrapper>
      <LabelText weight="bold">{t(toDosConstants.SORTED_BY)}</LabelText>
      <SelectSorting
        placeholder={
          <OptionText weight="regular">{sortingOptions[0].label}</OptionText>
        }
        suffixIcon={<Chevron direction="down" />}
        onChange={(sortOrder) => {
          setSortOrder(sortOrder)
        }}
      >
        <Select.Option
          key={sortingOptions[0].value + sortingOptions[0].label}
          value={sortingOptions[0].value}
          label={sortingOptions[0].label}
        >
          <OptionText weight="regular">{sortingOptions[0].label}</OptionText>
        </Select.Option>
        <Select.Option
          key={sortingOptions[1].value + sortingOptions[1].label}
          value={sortingOptions[1].value}
          label={sortingOptions[1].label}
        >
          <OptionText weight="regular">{sortingOptions[1].label}</OptionText>
        </Select.Option>
      </SelectSorting>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 24px 0 0;
  gap: 16px;
  margin-bottom: 12px;
`

const LabelText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const OptionText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`
const SelectSorting = styled(Select)`
  width: 176px;
` as typeof Select

export default SortDailyTasks
